import { css } from 'lit';

export const styles = css `
  :host {
    --_gap: var(--u-overflow-menu-items-gap, 8px);
    --_items-height: var(--u-icon-button-small-height, 40px);
    display: block;
  }

  .empty-space {
    height: var(--_items-height);
  }

  .items-set {
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: var(--_gap);
    max-height: var(--_items-height);
    overflow: hidden;
  }

  .container {
    display: grid;
    grid-template-columns: 1fr auto;
    margin-inline-start: calc(var(--_gap) * -1);
  }
  .container.show-menu {
    gap: var(--_gap);
  }

  .inner-menu {
    position: relative;
  }
`;
